
<template>
  <div id="landing_redeem" class="column pt0">
    <redeem-2fa v-if="!authorized" @getOptStatus="getOtpStatus"></redeem-2fa>
    <redeem-step1
      v-if="step == 1 && authorized"
      @callNext="callStepPreview"
      :feeTax="feeTax"
      :feeTaxAbsolute="feeTaxAbsolute"
      :redeemInfo="redeemInfo"
    ></redeem-step1>
    <redeem-step2
      v-if="step == 2"
      @callNext="callNextStep"
      @resetStep="setFirstStep"
      :previewData="previewData"
      :address="address"
      :feeTaxRush="feeTaxRush"
    ></redeem-step2>
    <redeem-step25
      v-if="step == 2.5"
      @callNext="callStepRedeem"
      @resetStep="step = 2"
      :previewData="previewData"
      :address="address"
      :redeemtype="redeemtype"
      :feeFixed="feeTaxAbsolute"
      :feeTaxRush="feeTaxRush"
      :feeTax="feeTax"
    ></redeem-step25>
    <redeem-step3
      v-if="step == 3"
      @confirmRedeem="redeemConfirm"
      @cancelRedeem="resetRedeem"
      :redeemData="redeemData"
      :loading="loading"
    ></redeem-step3>
    <redeem-step4
      v-if="step == 4"
      :redeemData="redeemData"
      :rush="redeemtype"
    ></redeem-step4>
    <redeem-step9
      v-if="step == 9 && authorized"
      @resetStep="setFirstStep"
      :error="error"
      :dayEnabled="redeemInfo.dayAllowed"
    ></redeem-step9>
  </div>
</template>
<script>
import Redeem2fa from "./redeem_steps/Redeem2fa";
import RedeemStep1 from "./redeem_steps/RedeemStep1";
import RedeemStep2 from "./redeem_steps/RedeemStep2";
import RedeemStep25 from "./redeem_steps/RedeemStep25";
import RedeemStep3 from "./redeem_steps/RedeemStep3";
import RedeemStep4 from "./redeem_steps/RedeemStep4";
import RedeemStep9 from "./redeem_steps/RedeemStep9";

import { mapGetters } from "vuex";
import { cryptoInput } from "../../../configs/global.js";
import Swal from "sweetalert2";

export default {
  created() {
    this.getOtpStatus();
    this.getDayOfWeek();
    this.getFees();

    this.getRedeems();
  },
  mounted() {},
  data: () => ({
    mode: "withdraw",
    redeemInfo: "",
    step: 1,
    previewData: "",
    redeemData: "",
    address: "",
    authorized: "",
    error: "",
    loading: false,
    redeemtype: "",
    feeFixed: "",
    blockRedeem: false,
    feeTax: "",
    feeTaxAbsolute: "",
    feeTaxRush: "",

    preview: {
      targetAmount: "",
      sourceCurrency: "BLU",
    },
    redeem: {
      sourceAmount: "",
      targetAddress: "",
      targetCurrency: "USDT",
    },
  }),
  components: {
    Redeem2fa,
    RedeemStep1,
    RedeemStep2,
    RedeemStep25,
    RedeemStep3,
    RedeemStep4,
    RedeemStep9,
  },
  methods: {
    async getRedeems() {
      let resp = await this.$store.dispatch("getRedeems");
      if (resp.status == 200) {
        let redeems = resp.data;
        if (redeems.length > 0) {
          for (let i in redeems) {
            if (redeems[i].status == "waiting") {
              this.blockRedeem = true;
            }
          }
        }
      }
    },
    async getFees() {
      let resp = await this.$store.dispatch("getFees");
      if (resp.status == 200) {
        let array = resp.data;
        let arrayRedeem = [];
        let arrayRedeemAbsolut = [];
        let arrayRedeemRush = [];

        for (let i in array) {
          if (array[i].type == "redeem") {
            if (array[i].math == "percent") {
              arrayRedeem.push(array[i]);
            }

            if (array[i].math == "absolut") {
              arrayRedeemAbsolut.push(array[i]);
            }

            if (array[i].math == "rush") {
              arrayRedeemRush.push(array[i]);
            }
          }
        }

        arrayRedeem.sort(function (a, b) {
          var c = new Date(a.createdAt);
          var d = new Date(b.createdAt);
          return d - c;
        });

        arrayRedeemAbsolut.sort(function (a, b) {
          var c = new Date(a.createdAt);
          var d = new Date(b.createdAt);
          return d - c;
        });

        console.log(arrayRedeemAbsolut);

        arrayRedeemRush.sort(function (a, b) {
          var c = new Date(a.createdAt);
          var d = new Date(b.createdAt);
          return d - c;
        });

        this.feeTax = arrayRedeem[0];
        this.feeTaxAbsolute = arrayRedeemAbsolut[0];
        this.feeTaxRush = arrayRedeemRush[0];
      } else {
        alert("Dont load the fees");
      }
    },

    resetRedeem() {
      this.step = 1;
      this.previewData = "";
    },

    async callStepPreview(amount, address, fee, data) {
      this.address = address;
      this.redeem.sourceAmount = parseFloat(amount);
      this.feeFixed = fee;
      this.previewData = data;

      if (this.blockRedeem) {
        Swal.fire({
          icon: "info",
          title: this.$t("msg.notification"),
          text: this.$t("msg.only_one_day"),
        });

        return;
      }

      this.step = 2;
    },

    async callNextStep(address, type) {
      this.address = address;
      this.redeemtype = type;
      this.redeem.targetAddress = address;

      try {
        let resp = await this.$store.dispatch("postRedeemPreview", this.redeem);
        this.previewData = resp.data;
        this.step = 2.5;
      } catch (e) {
        // this.step = 4
        console.log(e);
      }
    },

    async callStepRedeem() {
      let params = {
        sourceAmount: this.previewData.sourceAmount,
        targetAddress: this.address,
        targetCurrency: "USDT",
        rush: this.redeemtype,
      };
      try {
        let resp = await this.$store.dispatch("postRedeem", params);
        this.redeemData = resp.data;
        if (resp.status == 200) {
          this.step = 3;
          this.notifySuccess(
            this.$t("msg.check_your_email_for_pin_redeem"),
            5000
          );
        } else {
          this.step = 9;
        }
      } catch (e) {
        this.error = String(e);
        this.step = 9;
      }
    },

    async redeemConfirm(redeem) {
      let type = "redeem";

      try {
        let resp = await this.$store.dispatch("getTradeType", type);
        let trade = resp.data;
        redeem.id = trade.tradeId;
        this.$store.dispatch("updateBluAccount");
      } catch (e) {
        console.log(e);
      }

      try {
        let resp = await this.$store.dispatch("putRedeemConfirm", redeem);
        this.step = 4;
      } catch (e) {
        let error = String(e);
        let array = error.split(" ");
        let msgErro = "";

        array.shift();
        msgErro = array.join("_");

        this.notifyDanger(this.$t(`msg.${msgErro.toLowerCase()}`), 5000);
        this.loading = false;
      }
    },

    setFirstStep() {
      this.step = 1;
    },

    async getOtpStatus() {
      let resp = await this.$store.dispatch("getOtpStatus");
      console.log(resp.data)
      this.authorized = resp.data;
      this.$emit("updateOptStatus");
    },

    async getRedeemInfo() {
      let resp = await this.$store.dispatch("getRedeemInfo");
      this.redeemInfo = resp.data;

      var brTime = new Date().toLocaleString("en-US", {
        timeZone: "America/Sao_Paulo",
      });
      brTime = new Date(brTime);

      console.log(this.redeemInfo.todayBlocked);

      if (this.redeemInfo.todayBlocked) {
        this.step = 9;
      } else {
        this.step = 1;
      }
    },

    getDayOfWeek() {
      var brTime = new Date().toLocaleString("en-US", {
        timeZone: "America/Sao_Paulo",
      });
      brTime = new Date(brTime);
      let dayOfWeek = brTime.getDay();
      let hour = brTime.getHours();
      this.step = 1;
      if (dayOfWeek == 3 && hour < 17) {
        this.step = 1;
      } else {
        this.step = 9;
        //  this.step = 1;
      }
    },
    switchMode() {
      this.$emit("switchMode");
    },
  },
  computed: {
    ...mapGetters(["accounts"]),
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/components/private/services/RedemptionMain.vue